import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import './App.css';
import Home from './pages/Home';
import SingleChannel from './pages/SingleChannel';
import VideoPlayer from './pages/VideoPlayer';
import Search from './pages/Search';

import { LoginModal } from './components/LoginModal';
import Favorites from './pages/Favorites';

import { AlertProvider } from './AlertContext';
import Profile from './pages/Profile';

const GET_COUNTRY_URL = 'https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry';

async function getDefaultLanguage() {
  try {
    const res = await fetch(GET_COUNTRY_URL);
    const country = (await res.text()).trim();
    if (country === 'IQ') return 'ar';
  } catch (e) {
    // ignore; fall back to en
  }
  return 'en';
}

async function init() {
  const defaultLang = await getDefaultLanguage();
  window.__PK_DefaultLang = defaultLang;
  // Keep document in English so gtranslate can translate to ar when IQ
  document.documentElement.lang = 'en';

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <BrowserRouter>
      <AlertProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/video" element={<VideoPlayer />} />
          <Route path="/single" element={<SingleChannel />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/search" element={<Search />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
        <LoginModal />
      </AlertProvider>
    </BrowserRouter>
  );
}

init();

